import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';

import { getResponseMessage } from '../../../../../../utils/utils';
import { useFormatMessage } from '../../../../../../hooks';
import { ICompany } from '../../../../../../interfaces/companies';
import { getCompany } from '../../../../../../crud/companies.crud';

export function useGetCompany({ setCompany }: { setCompany?: (company: ICompany) => void }) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [companyFetch, setFetchCompany] = useState<ICompany | null>(null);
  const fm = useFormatMessage();

  const fetchCompany = useCallback(async (id: number) => {
    setLoading(true);
    getCompany(id)
      .then(res => {
        if (setCompany) {
          setCompany(res.data.data);
        }
        setFetchCompany(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { fetchCompany, companyFetch, loading };
}
